module.exports = __webpack_public_path__ + "static/img/banner_pc.240c084.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/module/active_80y/images/banner_pc.jpg
// module id = d1x8
// module chunks = 36